import Bog from './bog.icon.svg';
import BogInv from './bog.icon.inverse.svg';
import Tbc from './tbc.icon.svg';
import TbcInv from './tbc.icon.inverse.svg';
import Lib from './lib.icon.svg';
import Any from './any.icon.png';
import EMoney from './emoney.icon.svg';
import EPay from './ePay.icon.svg';
import TbcPay from './tbcPay.icon.svg';
import Oppa from './oppa.icon.svg';
import WebMoney from './webMoney.icon.svg';
import Lb from './lb.icon.svg';

import Success from './success.icon.svg';
import Fail from './fail.icon.svg';

import AddCard from './addCard.icon.svg';
import NoAddCard from './noAddCard.icon.svg';

import Info from './info.icon.svg';
import Card from './card.icon.svg';
import Map from './map.icon.svg';
import Video from './video.icon.svg';
import Back from './back.icon.svg';
import Resend from './resend.icon.svg';
import LeaderPay from "./leader.pay.icon.jpg"
import LEADER_CARD from "./leaderCard.png"
export {
  Bog,
  BogInv,
  Tbc,
  TbcInv,
  Lib,
  Any,
  Lb,
  EMoney,
  EPay,
  TbcPay,
  Oppa,
  WebMoney,
  LeaderPay,
  Info,
  Card,
  Success,
  Fail,
  Map,
  Video,
  Back,
  AddCard,
  NoAddCard,
  Resend,
  LEADER_CARD
};
export const BankLogos = { "BOG":Bog, "TBC":Tbc, "LIB":Lib, "ANY":Any,"LEADER_CARD":LEADER_CARD };
export const BankLogosInv = { "BOG": BogInv, "TBC": TbcInv, "LIB":Lib, "ANY":Any,"LEADER_CARD":LEADER_CARD };
export const WalletLogos = { EMoney, TbcPay, Oppa, WebMoney,LeaderPay ,Lb};
export const DepositLogos = { EPay, TbcPay, Oppa,Lb };
export const CashDeskLogos = { Lb, LeaderPay, Tbc };
export const IdLogos = { Bog, Lib };
export const Results = { Success, Fail };
